// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from '../../link';
import type { Theme } from '../../../types';
import { getAssortmentPageLink, getCarAddButtonText } from '../../../store/compareSettings/selectors';
import { getActiveItem } from '../../../store/routes';

import { toggleCompareOpen } from '../../../store/pdbComparison';

type DispatchProps = {|
  onTogglePdbCompare: Function,
|};

type OwnProps = {|
  className?: ?string, // eslint-disable-line react/require-default-props
|};

type StateProps = {|
  assortmentPageLink: string,
  carAddButtonText: string,
  activeRouteItem: ?string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const Icon = styled<any, Theme>('i')`
  background-color: ${props => props.theme.compareTable.addButton.iconBackground};
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.75rem;
  color: ${props => props.theme.compareTable.addButton.iconColor};
`;

const AddButtonContainer = styled<any, Theme>('div')`
  button, a {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: ${props => props.theme.compareTable.addButton.color};
    text-decoration: none;
    font-size: inherit;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const AddButtonComponent = ({
  className,
  assortmentPageLink,
  carAddButtonText,
  activeRouteItem,
  onTogglePdbCompare,
}: Props) => {
  if (assortmentPageLink === activeRouteItem) {
    return (
      <AddButtonContainer>
        <button
          type="button"
          className={className}
          onClick={onTogglePdbCompare}
        >
          <Icon className="icon-plus" />
          {carAddButtonText}
        </button>
      </AddButtonContainer>
    );
  }
  return (
    <AddButtonContainer>
      <Link
        className={className}
        href={assortmentPageLink}
      >
        <Icon className="icon-plus" />
        {carAddButtonText}
      </Link>
    </AddButtonContainer>
  );
};


const mapStateToProps = (state): StateProps => ({
  assortmentPageLink: getAssortmentPageLink(state),
  carAddButtonText: getCarAddButtonText(state),
  activeRouteItem: getActiveItem(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onTogglePdbCompare: () => dispatch(toggleCompareOpen()),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(AddButtonComponent);
